export default __webpack_public_path__ + "fonts/account-page-plan-legacy.svg";